import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { asyncConnect } from 'react-async-client';

import { putDocumentText } from 'actions/asyncActions';
import FreeForm from 'components/modals/events/result/forms/FreeForm';
import ErrorHTML from 'components/common/form/ErrorHTML';
import withFormWrapper from 'components/hocs/withFormWrapper';

@asyncConnect({
    formAction: putDocumentText
        .withSuccessHandler(({ close }) => close())
        .withOptions({ resetOnUnmount: true })
})
@withFormWrapper({
    scrollToInvalid: '.ant-modal-body',
    mapPropsToValues: ({ document, body }) => ({
        id: document.id,
        fileType: document.fileType,
        result: { body }
    })
})
export default class DocumentEditText extends Component {
    static propTypes = {
        footer: PropTypes.func.isRequired,
        document: PropTypes.object.isRequired,
        body: PropTypes.string.isRequired,
        className: PropTypes.string,
        formAction: PropTypes.object,
        handleSubmit: PropTypes.func
    };

    render() {
        const { footer, handleSubmit, className } = this.props;
        const { meta } = this.props.formAction;

        return (
            <div className={className}>
                <FreeForm />
                {meta.error && <ErrorHTML meta={meta} />}
                {footer(handleSubmit)}
            </div>
        );
    }
}
